import { createFileRoute } from "@tanstack/react-router";
import { COMMERCIAL_SOLAR_FAQS } from "@/components/landing/lp-commercial-solar-pv";
import { lazyNamed } from "@/lib/lazy-route";
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";

const LpCommercialSolarPvPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-solar-pv"),
  "LpCommercialSolarPv",
);

const PATH = "/commercial-solar-pv";
const TITLE = "Commercial Solar PV South Wales & South West | Framework-Ready | CRS Energy";
const DESCRIPTION =
  "MCS certified commercial solar PV design and delivery for councils, housing associations, FMs and main contractors. Framework-ready, with documented quality, carbon and social-value reporting.";
const BREADCRUMB_NAME = "Commercial Solar PV";

export const Route = createFileRoute("/commercial-solar-pv")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Commercial Solar PV",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_SOLAR_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
    ],
  }),
  component: LpCommercialSolarPvPage,
});
